import { styled, Box } from '@mui/material';

export const Flex = styled(Box)<{
  gap?: number | string;
  column?: boolean;
  noCenter?: boolean;
  contectCenter?: boolean;
  p?: number | string;
  noFlex?: boolean;
  flexEnd?: boolean;
  flex?: number;
  spaceBetween?: boolean;
  fullHeight?: boolean;
  alignEnd?: boolean;
  pointer?: boolean;
  noFull?: boolean;
}>`
  display: flex;
  position: relative;
  width: ${({ noFull }) => (noFull ? 'fit-content' : '100%')};
  flex: ${({ noFlex, flex }) => (noFlex ? '0' : flex ? flex : 1)};
  flex-direction: ${({ column }) => (column ? 'column' : 'row')};
  align-items: ${({ noCenter, alignEnd }) =>
    alignEnd ? 'flex-end' : noCenter ? 'flex-start' : 'center'};
  gap: ${({ gap }) => (gap ? gap : 16)}px;
  justify-content: ${({ contectCenter, flexEnd, spaceBetween }) =>
    contectCenter
      ? 'center'
      : flexEnd
      ? 'flex-end'
      : spaceBetween
      ? 'space-between'
      : 'flex-start'};
  padding: ${({ p }) => (p ? p : 0)}px;
  height: ${({ fullHeight }) => (fullHeight ? '100%' : 'fit-content')};
  cursor: ${({ pointer }) => (pointer ? 'pointer' : 'default')};
`;
